import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { createFileRoute, Link, type SearchSchemaInput } from '@tanstack/react-router'
import { Check, X } from 'lucide-react'

export const Route = createFileRoute('/shop/payment/verify/')({
  validateSearch: (search?: Record<string, unknown> & SearchSchemaInput): {refCode: string, ok: boolean | null} | null => {
    
    if (search && Object.keys(search).length > 0) {

      return {
        refCode: search.refCode as string || '',
        ok: search.ok as boolean || null, 
      }
    } 
    return null
  },
  component: RouteComponent,
})

function RouteComponent() {

  const result = Route.useSearch()

  if (!result) {
    return <>خطایی پیش امده است</>
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          {result?.ok ? 'پرداخت موفق' : 'پرداخت ناموفق'}
        </CardTitle>
      </CardHeader>
      <CardContent className='flex flex-col gap-5 justify-center items-center'>
        {result.ok ? <>
          <Check size={50} className='text-green-500'/>
          <p className='font-bold text-xl no-font'>پرداخت با موفقیت انجام شد</p>
          <p>کد پیگیری: {result.refCode}</p>
          <Link to="/shop/orders">
            <Button>
              رفتن به سفارشات
            </Button>
          </Link>
        </> : <>
          <X size={50} className='text-red-500'/>
          <p className='font-bold text-xl no-font'>پرداخت انجام نشد</p>
          <p>کد پیگیری : {result.refCode}</p>
          <Link to="/shop">
          <Button>
            فروشگاه
          </Button>
          </Link>
        </>}
      </CardContent>
    </Card>
  )
}
